import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import EBTDetails from '../../subdepartmentdetails/EBT'


function EBT() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Electronic Benefits Transfer (EBT) || SNAP";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="SNAP"
            title="Electronic Benefits Transfer (EBT)"
            subtitledown="Department of Family & Children Services"
           />
            <EBTDetails/>
        </div>
    </>
  )
}

export default EBT



